<template>
  <component
    :is="to ? BaseLink : BaseButton"
    :aria-describedby="tileDescriptionId"
    :aria-labelledby="tileTitleId"
    class="w-full f-col items-center b-transparent text-center duration "
    :class="[brandClasses.tile, tileSpacingClasses[spacing], { 'pointer-events-none': disabled }]"
    data-test-id="vf-tile"
    :disabled
    style="border-top-width: 3px; gap: 0.3125rem"
    :to
  >
    <slot name="icon">
      <vf-icon :name="icon" size="2xl" />
    </slot>
    <span :id="tileTitleId" class="title-3 ">
      <slot name="title">
        {{ title }}
      </slot>
    </span>
    <span v-if="description" :id="tileDescriptionId" class="ws-pre-wrap text-sm c-black ">
      <slot name="description">
        {{ description }}
      </slot>
    </span>
    <vf-button v-if="cta" class="mt-6 flex" size="xs">
      {{ cta }}
      &nbsp;<vf-icon name="arrow" size="md" />
    </vf-button>
  </component>
</template>

<script lang="ts" setup>
import type { IconName } from '#types/icon'
import type { TileSpacing } from '#types/sizes'
import { BaseButton, BaseLink } from '#components'

const { spacing = 'sm' } = defineProps<{
  icon: IconName
  title: string
  description?: string
  to?: string
  disabled?: boolean
  cta?: string
  spacing?: TileSpacing
}>()

const { brandClasses } = useAppConfig().components.vf.tile
const id = useId()
const tileTitleId = `tile-title-${id}`
const tileDescriptionId = `tile-desc-${id}`
const tileSpacingClasses: Record<TileSpacing, string> = {
  sm: 'px-4 py-6',
  md: 'py-8 px-10 md:px-6 lg:px-20',
  lg: 'px-8 py-6 md:py-12',
}
</script>
